import { render, staticRenderFns } from "./iti-menu-group.html?vue&type=template&id=9005864c&scoped=true&"
import script from "./iti-menu-group.ts?vue&type=script&lang=ts&"
export * from "./iti-menu-group.ts?vue&type=script&lang=ts&"
import style0 from "./iti-menu-group.scss?vue&type=style&index=0&id=9005864c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9005864c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListGroup,VListItem,VListItemTitle})
